<template>
  <div>
    <el-divider content-position="left">联系人</el-divider>
    <el-row :gutter="20" align="middle" type="flex">
      <el-col :span="4"><div class="info-left">
        <i class="el-icon-map-location" v-show="hasContact"></i>
      </div></el-col>
      <el-col :span="16" class="info-add" v-if="hasContact">
        <div  @click="changeContact()">
          <p id="s_username">{{contact.name}}</p>
          <p id="s_phone">{{contact.phone}}</p>
          <div id="s_address">{{contact.province}}{{contact.address}}</div>
        </div>
      </el-col>
      <el-col :span="16" v-else>
        <div class="no_contact" @click="changeContact()">请添加联系人信息</div>
      </el-col>
      <el-col :span="4"><div class="info-right">
        <div class="el-icon-arrow-right" @click="changeContact()"></div>
      </div></el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "Contact",
    data(){
        return{
            contact: {},
            hasContact: false,
            unionid:''
        }
    },
    created() {
        this.unionid = window.localStorage.getItem("fastunionid");
    },
    mounted:function() {
        if (this.$route.params.contact) {
            this.contact = this.$route.params.contact;
            this.hasContact = true
        }
    },
    activated() {
        this.unionid = window.localStorage.getItem("fastunionid");
        if (this.$route.params.contact) {
            // 联系人列表中选择某一条数据后，路由返回信息
            this.contact = this.$route.params.contact;
            this.hasContact = true
        }
        if (!this.hasContact) {
            // 若当前无联系人数据，则查询默认地址
            // this.$axios.get(this.$baseURL + `/contact/default/` + this.$unionId)
            this.$axios.get(this.$baseURL + `/contact/default/` + window.localStorage.getItem("fastunionid"))
                .then(data=> {
                    this.contact = data.data;
                    this.hasContact = true
                })
                .catch(error=> {
                    console.log(error);
                });
        }
    },
    methods:{
        changeContact () {
            this.$router.push({
                name:"AddressInfo"
            })
        },
    }
  }
</script>

<style scoped>
  .info-left,.info-right{
    font-size: 30px;
  }
  .info-add {
    text-align: left;
    margin: 10px 0px;
  }
  .info-add p {
    color: #333333;
    font-size: 15px;
    margin: 0px 0px 6px 0px;
    font-weight: 600;
  }
  .info-add div {
    color: #999999;
    font-size: 12px;
  }
  .no_contact {
    color: #999999;
    font-size: 14px;
  }
</style>
